export default __webpack_public_path__ + "static/media/concierge-default.0f4cd1a0.png";